import type * as Types from 'app/types/graphql';

import { ShopPlatformRevenueSelectFragmentDoc } from '../fragments/shopPlatformPlan.generated';
import { UsageFeeBillSelectFragmentDoc } from '../fragments/usageFeeBill.generated';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type UsageFeeBillRetryMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type UsageFeeBillRetryMutationResponse = {
  usageFeeBillRetry?: Types.Maybe<
    Pick<
      Types.UsageFeeBill,
      'id' | 'cycleStartDate' | 'cycleEndDate' | 'status' | 'price' | 'usageAmount' | 'paidAt'
    > & {
      revenue?: Types.Maybe<Pick<Types.ShopPlatformRevenue, 'id' | 'date' | 'totalRevenue'>>;
      shopPlatformPlan?: Types.Maybe<Pick<Types.ShopPlatformPlan, 'id' | 'planID'>>;
    }
  >;
};

export const UsageFeeBillRetryDocument = `
    mutation UsageFeeBillRetry($id: ID!) {
  usageFeeBillRetry(id: $id) {
    ...UsageFeeBillSelect
  }
}
    ${UsageFeeBillSelectFragmentDoc}
${ShopPlatformRevenueSelectFragmentDoc}`;

export const useUsageFeeBillRetryMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UsageFeeBillRetryMutationResponse,
    TError,
    UsageFeeBillRetryMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UsageFeeBillRetryMutationResponse,
    TError,
    UsageFeeBillRetryMutationVariables,
    TContext
  >(
    ['UsageFeeBillRetry'],
    (variables?: UsageFeeBillRetryMutationVariables) =>
      appFetcher<UsageFeeBillRetryMutationResponse, UsageFeeBillRetryMutationVariables>(
        UsageFeeBillRetryDocument,
        variables,
      )(),
    options,
  );
};

useUsageFeeBillRetryMutation.getKey = () => ['UsageFeeBillRetry'];
